export const Diet = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6471 21.2646L12.5 21.2351L12.3529 21.2646C9.97627 21.7399 7.73257 21.4756 6.09352 20.1643C4.46312 18.86 3.25 16.374 3.25 12C3.25 7.5268 4.25792 5.70951 5.58541 5.04577C6.27977 4.69859 7.17771 4.59755 8.32028 4.72939C9.46149 4.86107 10.7783 5.21665 12.2628 5.71149L12.5235 5.79837L12.7785 5.69634C15.2602 4.70363 17.4909 4.32336 19.0578 5.05459C20.5271 5.74026 21.75 7.59322 21.75 12C21.75 16.374 20.5369 18.86 18.9065 20.1643C17.2674 21.4756 15.0237 21.7399 12.6471 21.2646Z"
      fill="black"
      fillOpacity={0.56}
    />
    <path d="M12.5 5.5C16 3 11.5 2 9.5 2" fill="black" fillOpacity={0.56} />
  </svg>
);
